import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Acquisto, Lavorazione, VoceAcquisto } from "../_Models";
import { Azienda } from "../../Admin/models/Azienda";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApiRestService as ClientiApiRestService } from "../../Admin/_service/api-rest.service";
import { ApiRestService } from "../api-rest.service";
import { AcquistiAggiunteEditComponent } from "../acquisti-aggiunte-edit/acquisti-aggiunte-edit.component";
import { ApiPathsService } from "../../api-paths.service";
import { ToastrService } from "ngx-toastr";
import { DuplicaAcquistoModalComponent } from "../duplica-acquisto-modal/duplica-acquisto-modal.component";
import { DatePipe } from "@angular/common";
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-acquisti-edit',
  templateUrl: './acquisti-edit.component.html'
})
export class AcquistiEditComponent implements OnInit {
  @Input() isModal: boolean = false;
  @Input() acquisto: Acquisto;
  @Output() Saved = new EventEmitter<boolean>();
  OnArrivatiClick: EventEmitter<any> = new EventEmitter<any>();
  Fornitori: Azienda[] = [];
  FornitoriSelezionati: Azienda[] = [];
  clientiDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'nominativo',
    allowSearchFilter: true,
  };
  Stampe: any;
  invioAdhoc: boolean;
  constructor(
    private ngbActiveModal: NgbActiveModal,
    private ngbModal: NgbModal,
    private clientiApiRest: ClientiApiRestService,
    private apiRestService: ApiRestService,
    private apipaths: ApiPathsService,
    private toastservice: ToastrService,
    private datePipe: DatePipe

  ) { }

  ngOnInit(): void {
    this.refresh();
    this.OnArrivatiClick.subscribe(data => {
      console.log('OnArrivatiClick: ', data);
      if (data && data?.item?.consegnati != data?.item?.quantita) {
        var stock = new Lavorazione(data.item?.id);
        stock.data = this.datePipe.transform(new Date(), "yyyy-MM-dd");
        stock.quantita = data.item?.quantita;
        this.apiRestService.PrimaNotaStockAdd(stock).subscribe(() => {
          this.refresh();
          this.toastservice.success('Operazione eseguita con successo')
        })
      } else {
        this.toastservice.warning('Questo Prodotto è stato già consegnato in precedenza')
      }
    })
  }
  refresh() {
    this.clientiApiRest.getListaAziende({ ruolo: "F", page: 0, size: 10 }).subscribe(data => {
      this.Fornitori = data?.data;
      if (data?.data?.length == 1 && !this.acquisto?.id)
        this.FornitoriSelezionati = data?.data;
    });
    if (this.acquisto.id) {
      this.apiRestService.PrimaNotaAcquistiGet(this.acquisto).subscribe(data => {
        this.acquisto = data.data;
        this.Stampe = data.stampe;
        this.FornitoriSelezionati = [this.acquisto.clienteObject];
      })
    } else {
      var oggi = new Date();
      var piu75 = new Date();
      var piu60 = new Date();
      piu60.setDate(piu60.getDate() + 60);
      piu75.setDate(piu75.getDate() + 75);
      this.acquisto.data_prevista = this.datePipe.transform(piu60, 'yyyy-MM-dd');
      this.acquisto.data_pagamento_p = this.datePipe.transform(piu75, 'yyyy-MM-dd');
      this.acquisto.data_emissione = this.datePipe.transform(oggi, 'yyyy-MM-dd');
      this.acquisto.anno = this.datePipe.transform(oggi, 'yyyy');
    }
  }
  GetData() {
    this.acquisto.cliente = this.FornitoriSelezionati[0]?.id;
    return this.acquisto;
  }
  save() {
    if (this.acquisto.id) {
      this.apiRestService.PrimaNotaAcquistiUpdate(this.GetData()).subscribe(() => {
        this.Saved.emit(true);
        this.close();
      })
    } else {
      this.apiRestService.PrimaNotaAcquistiAdd(this.GetData()).subscribe(() => {
        this.Saved.emit(true);
        this.close();
      })
    }
  }

  close() {
    this.ngbActiveModal.dismiss();
  }

  FornitoreChanged() {
    if (this.FornitoriSelezionati?.length > 0 && this.FornitoriSelezionati[0] && !(this.acquisto && this.acquisto.nominativo != "" && this.acquisto.nominativo && !(this.acquisto.nominativo != this.FornitoriSelezionati[0]?.nominativo && this.Fornitori.find(x => x.nominativo == this.acquisto.nominativo) != undefined)))
      this.clientiApiRest.getInfoAziende(this.FornitoriSelezionati[0]).subscribe(data => {
        this.acquisto.nominativo = data.nominativo;
        this.acquisto.indirizzo = data.indirizzo;
        this.acquisto.cap = data.cap;
        this.acquisto.citta = data.citta;
        this.acquisto.provincia = data.provincia;
        this.acquisto.nazione = data.nazione;
        this.acquisto.piva = data.piva;
        this.acquisto.cf = data.cf;
      })
  }

  EditVoce(item?: VoceAcquisto) {
    let modale = this.ngbModal.open(AcquistiAggiunteEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<AcquistiAggiunteEditComponent>modale.componentInstance).isModal = true;
    (<AcquistiAggiunteEditComponent>modale.componentInstance).VoceAcquisto = item ?? new VoceAcquisto();
    (<AcquistiAggiunteEditComponent>modale.componentInstance).Saved.subscribe(voce => {
      if (!item)
        this.acquisto?.voci?.push(voce)
      else if (voce?.id) {
        this.apiRestService.PrimaNotaAcquistiVoceUpdate(voce).subscribe(data => {
          this.refresh();
        })
      }
    });
    (<AcquistiAggiunteEditComponent>modale.componentInstance).fornitore = this.FornitoriSelezionati?.length > 0 ? this.FornitoriSelezionati[0] : undefined;
  }

  DeleteVoce(item: VoceAcquisto) {
    const idx: number = this.acquisto?.voci?.findIndex(x => x == item);
    if (idx > -1) {
      this.acquisto?.voci?.splice(idx, 1);
    }
  }

  Duplica(voce: VoceAcquisto) {
    const duplica = this.ngbModal.open(DuplicaAcquistoModalComponent, {
      centered: true,
      backdrop: 'static',
      size: 'sm',
    });
    (<DuplicaAcquistoModalComponent>duplica.componentInstance).Voce = voce;
    (<DuplicaAcquistoModalComponent>duplica.componentInstance).onDuplicaClick.subscribe(duplicato => {
      this.acquisto?.voci?.push(duplicato)
    });
  }

  InviaAdhoc() {
    this.invioAdhoc = true
    this.apipaths.ClassicPost('/primanota/acquisti/adhoc', { id: this.acquisto?.id }).subscribe(() => {
      this.invioAdhoc = false;
      this.toastservice.success("Importazione avvenuta con succcesso");
      this.refresh();
    })
  }
  CampiAggiuntiviVoci() {
    var buttons = [];
    if (!this.environment['AcquistiAddOn'] || !this.environment['AcquistiAddOn']['hideBrand'])
      buttons = [...buttons, ...[{ nome: 'Brandizzato', oggetti: ['brandizzato'], type: 'boolean' }, { nome: 'Brand', oggetti: ['brand'], type: 'string' }]]
    return buttons;
  }

  environment = environment;
}
